module.exports = __webpack_public_path__ + "img/img (49).4be3708a.jpg";